import { render, staticRenderFns } from "./giftEdit.vue?vue&type=template&id=8a8c8810&scoped=true"
import script from "./giftEdit.vue?vue&type=script&lang=js"
export * from "./giftEdit.vue?vue&type=script&lang=js"
import style0 from "./giftEdit.vue?vue&type=style&index=0&id=8a8c8810&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8c8810",
  null
  
)

export default component.exports